import ReactLoading from 'react-loading';

import { PaymentMethodType } from '../common/constants';

const AuthenticationView = ({paymentMethodType, authViewHtml, authViewUrl}) => {
    if (paymentMethodType === PaymentMethodType.Wallet) {
        return (
            <div>
                <div className='row mt-4'>
                    <h4>Confirm the payment request with your wallet</h4>
                </div>
                <div className='row mt-4'>
                    <p>We sent a request to your wallet provider. You will find it in your wallet application or you will get an SMS with instructions to follow</p>
                </div>
                <br />
                <div className='row mt-2'>
                    <div
                        style={{
                            width: "100%",
                            height: "100",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <ReactLoading type={"spin"} height={70} width={70} color={this.primaryColor} />
                    </div>
                </div>
                <br />
                <div className='row mt-4 pb-2'>
                    <h4>Awaiting payment confirmation</h4>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                {authViewHtml && <iframe 
                    title="OTP Verfication"
                    className="iframe-card"
                    id="iframe"
                    srcDoc={authViewHtml} />}
                {authViewUrl && <iframe 
                    title="OTP Verfication"
                    className="iframe-card"
                    id="iframe"
                    src={authViewUrl} />}
            </div>
        )
    }
};

export default AuthenticationView;
